(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["localization"] && !Shopify.designMode) return;
  try {
    // market select dropdown/localisation
  class MarketSelect extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.dataset.originalValue = this.form.querySelector('select').value;

      //Handle the user requesting a market change
      this.form.addEventListener('input', (event) => this.redirectToNewMarket(event));
    }
    redirectToNewMarket(event) {
      var newUrl = event.target.value;
      location.href = 'https://' + newUrl;
    }
  }
  if (!customElements.get('market-select')) {
    customElements.define('market-select', MarketSelect);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card-badge"] && !Shopify.designMode) return;
  try {
    class DropTimeBadge extends HTMLElement {
    constructor() {
      super();
      this.timer = null;
    }

    connectedCallback() {
      this.updateBadge();
      // Update the countdown every minute
      this.timer = setInterval(() => this.updateBadge(), 60000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    updateBadge() {
      const targetEpoch = Number(this.dataset.dropEpoch) * 1000;
      const diffMs = targetEpoch - Date.now();

      if (diffMs <= 0) {
        if (this.timer) clearInterval(this.timer);
        this.classList.remove('drop-time-badge--active');
        return;
      }

      const totalDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
      const totalHours = Math.floor(diffMs / (1000 * 60 * 60));
      const totalMinutes = Math.ceil((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      this.querySelectorAll('.drop-time-badge__text--active').forEach((el) =>
        el.classList.remove('drop-time-badge__text--active')
      );
      let dropTimeBadgeText;
      let numberForUi;
      if (totalDays > 0) {
        dropTimeBadgeText = this.querySelector('.drop-time-badge--days');
        numberForUi = totalDays;
      } else if (totalHours > 0) {
        dropTimeBadgeText = this.querySelector('.drop-time-badge--hours');
        numberForUi = totalHours;
      } else {
        dropTimeBadgeText = this.querySelector('.drop-time-badge--minutes');
        numberForUi = totalMinutes;
      }
      dropTimeBadgeText.classList.add('drop-time-badge__text--active');
      dropTimeBadgeText.querySelector('span').textContent = numberForUi;
      this.classList.add('drop-time-badge--active');
    }
  }

  // Register the custom element
  customElements.define('drop-time-badge', DropTimeBadge);
  } catch(e) { console.error(e); }
})();

})();
